import axios from 'axios'
axios.defaults.withCredentials = true;
const url = 'http://www.api.ucpvirtual.com.br/api/v2/med/'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default {
    
    actions:{
      

          AllMaterias (context, value) {
            console.log(value)
        
            // context.commit('PRELOADER_MUDAR', true)
             const AuthStr = 'Bearer ' + localStorage.getItem('access_token')
        
             axios.get(url + 'materias/2160',
              {
                headers: {
                  'Authorization': AuthStr,
                  'Content-Type': 'application/json',
                },
              })
              .then(response => {
                //  console.log(response.data)
                 context.commit('SET_MATERIAS', response.data)
                 return true
              })
              .catch((error) => {
                console.log(error.response.data.message)
              }).finally( () => {
                    //   context.commit('PRELOADER_MUDAR', false)
              })
          },

        

    },
    getters:{

    },
    mutations:{
        SET_MATERIAS (state, value) {
            state.AllMaterias =  value
          },

    },
    state:{
        AllMaterias: [],

    },
}